import { reactive } from 'vue'

let seq = 0

export const toasts = reactive({ items: [] })

function push(type, message, duration) {
  const id = ++seq
  toasts.items.push({ id, type, message })
  if (duration) setTimeout(() => dismiss(id), duration)
  return id
}

export function dismiss(id) {
  const i = toasts.items.findIndex((t) => t.id === id)
  if (i >= 0) toasts.items.splice(i, 1)
}

export const toast = {
  success: (message) => push('success', message, 4000),
  info: (message, duration = 4000) => push('info', message, duration),
  error: (message) => push('error', message, 8000)
}
